import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Rocket } from "lucide-react";
import { api } from "@/lib/api";
import { Avatar } from "@/components/Avatar";
import { ProtectedMedia } from "@/components/ProtectedMedia";

export function SpotlightStrip() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/boost/spotlight").then(({ data }) => setItems(data.results || [])).catch(() => setItems([]));
  }, []);

  if (!items || items.length === 0) return null;

  return (
    <div className="mj-card p-4" data-testid="spotlight-strip">
      <div className="flex items-center gap-2 mb-3">
        <span className="w-8 h-8 rounded-lg bg-[#FAF3E0] flex items-center justify-center"><Rocket className="w-4 h-4 text-[#C59B27]" /></span>
        <h2 className="font-serif text-lg font-semibold text-[#58111A]">Spotlight</h2>
        <span className="text-xs text-[#9E7B1B] hidden sm:inline">Featured profiles right now</span>
      </div>
      <div className="flex gap-3 overflow-x-auto hide-scrollbar pb-1 -mx-1 px-1">
        {items.map((p) => (
          <button
            key={p.user_id}
            onClick={() => nav(`/app/profile/${p.user_id}`)}
            data-testid={`spotlight-card-${p.user_id}`}
            className="shrink-0 w-[150px] text-left group"
          >
            <ProtectedMedia className="rounded-xl overflow-hidden aspect-[4/5] bg-slate-100 ring-2 ring-[#C59B27]/50 shadow-sm">
              <Avatar photos={p.photos} name={p.full_name} size={9999} className="w-full h-full group-hover:scale-105 transition-transform duration-500" />
            </ProtectedMedia>
            <div className="mt-1.5">
              <div className="text-sm font-semibold text-[#261A1C] truncate">{p.full_name}{p.age ? `, ${p.age}` : ""}</div>
              <div className="text-[11px] text-[#605255] truncate">{[p.city, p.occupation].filter(Boolean).join(" · ") || "\u00a0"}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
